/** Temporary private rollout; server authorization remains authoritative. */
export const LASER_KPI_PREVIEW_USERS = ["riccardo", "giorgio"];

export function canAccessLaserKpi(user) {
    return user?.is_active !== false && LASER_KPI_PREVIEW_USERS.includes(user?.username) &&
        (user.is_superuser === true || user.admin === true || (user.groups || []).some(group => ["Laser", "Tecnici", "Milkrun", "Schedulazione", "Amministrazione"].includes(typeof group === "string" ? group : group.name)));
}
